// extracted by mini-css-extract-plugin
export var dropdown = "_gk-0";
export var imagePlaceholder = "_gk-2";
export var imageWrapper = "_gk-3";
export var productImage = "_gk-1";
export var truncateContainer = "_gk-4";
export var truncateText = "_gk-5";